import { useAtomValue } from 'jotai';

import { Unit } from '@core';
import { useKeyParameter } from '@hooks';
import { useTranslate } from '@i18n';
import { Box, ElvaLogo, Heading2 } from '@ui';

import { statusLabelAtom, uiBeastStatusAtom } from '../../store/status';
import { FloorActivityNavigation } from '../ActivityNavigation/ActivityNavigation';

import * as css from './Sidebar.css';

export const Sidebar = () => {
    const statusLabel = useAtomValue(statusLabelAtom);

    const keyParameterNode = useKeyParameter();
    const beastStatus = useAtomValue(uiBeastStatusAtom);
    const t = useTranslate();

    return (
        <div className={css.sidebar}>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                alignItems="center"
                flex={1}
                className={css.sidebarWrapper}
            >
                <FloorActivityNavigation
                    parameterID={keyParameterNode?.parameter?.name}
                    parameterName={t(keyParameterNode?.i18n ?? '-')}
                    parameterUnit={keyParameterNode?.parameter?.unit as Unit}
                />
                <Box paddingBlock={16}>
                    <ElvaLogo width={112} status={beastStatus} />
                    <Heading2 textAlign="center" pt={16}>
                        {statusLabel}
                    </Heading2>
                </Box>
            </Box>
        </div>
    );
};
